import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const BlurText = ({ text, className = "", delay = 0 }) => {
    const containerRef = useRef(null);
    const wordsRef = useRef([]);

    useEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        // Clean up references
        wordsRef.current = wordsRef.current.slice(0, text.split(" ").length);

        gsap.fromTo(wordsRef.current,
            {
                filter: 'blur(10px)',
                opacity: 0,
                y: 50 // Move from bottom (50px down)
            },
            {
                filter: 'blur(0px)',
                opacity: 1,
                y: 0, // To original position (up)
                duration: 1,
                stagger: {
                    each: 0.05,
                    from: "end" // "reverse teks nya" -> reverse the stagger order
                },
                ease: "power2.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 80%",
                    end: "bottom 20%",
                    toggleActions: "play reverse play reverse",
                },
                delay: delay
            }
        );
    }, [text, delay]);

    const words = text.split(" ");

    return (
        <div 
            ref={containerRef} 
            className={`flex items-center justify-center min-h-[60vh] w-full px-6 py-12 ${className}`} 
            style={{ perspective: '1000px' }}
        >
            <div className="max-w-4xl text-center">
                {words.map((word, i) => (
                    <span
                        key={i}
                        ref={el => wordsRef.current[i] = el}
                        style={{ display: 'inline-block', marginRight: '0.3em', willChange: 'transform, opacity, filter' }}
                    >
                        {word}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default BlurText;
